import React, { useEffect } from 'react';
import useStateRef from "react-usestateref";
import './index.css';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import OutsideClickHandler from 'react-outside-click-handler';
import EventEmitter from 'src/utils/EventEmitter';
import Checkbox from '@mui/material/Checkbox';
import CheckBoxRoundedIcon from '@mui/icons-material/CheckBoxRounded';
import CheckBoxOutlineBlankRoundedIcon from '@mui/icons-material/CheckBoxOutlineBlankRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import RadioButtonCheckedRoundedIcon from '@mui/icons-material/RadioButtonCheckedRounded';
import RadioButtonUncheckedRoundedIcon from '@mui/icons-material/RadioButtonUncheckedRounded';
import Enumerable from "linq";

const SelectMenuPage = (props) => {

  const [title, setTitle, titleRef] = useStateRef(props.selectMenuType);
  const [selectedMenu, setSelectedMenu, selectedMenuRef] = useStateRef(props.selectMenuType === "filters" && props.currentSelectMenu === 0 ? [] : props.currentSelectMenu);
  const [maxHeight, setMaxHeight, maxHeightRef] = useStateRef("90%");
  const [data, setData, dataRef] = useStateRef([]);
  const sortList = ["Product Name A-Z", "Product Name Z-A", "Popular Products"]
  const categoryList = [
    { Name: 'Category 1', Id: '1' },
    { Name: 'Category 2', Id: '2' },
    { Name: 'Category 3', Id: '3' },
    { Name: 'Category 4', Id: '4' },
    { Name: 'Category 5', Id: '5' }
  ]

  const [doseFormatList, setDoseFormatList, doseFormatListRef] = useStateRef([]);
  const [supplierNameList, setSupplierNameList, supplierNameListRef] = useStateRef([]);
  const [selectedCategory, setSelectedCategory, selectedCategoryRef] = useStateRef([]);
  const [selectedDoseFormat, setSelectedDoseFormat, selectedDoseFormatRef] = useStateRef([]);
  const [selectedSupplierName, setSelectedSupplierName, selectedSupplierNameRef] = useStateRef([]);

  useEffect(() => {
    if (props) {
      if (props.category) {
        setSelectedCategory(props.category)
      }

      if (props.doseFormat) {
        setSelectedDoseFormat(props.doseFormat)
      }

      if (props.supplier) {
        setSelectedSupplierName(props.supplier)
      }
    }
  }, [props.category, props.doseFormat, props.supplier])

  useEffect(() => {
    var count = 50;
    if (props.selectMenuType === "sort_by") {
      setTitle("");
      setData(sortList);
      // count = sortList.length * 9;
    } else if (props.selectMenuType === "filters") {
      setTitle("Filters")

      if (JSON.parse(localStorage.getItem('dose_format'))) {
        const doseFormat = JSON.parse(localStorage.getItem('dose_format'));
        setDoseFormatList(doseFormat)
      }

      if (JSON.parse(localStorage.getItem('supplier_data'))) {
        const supplierData = JSON.parse(localStorage.getItem('supplier_data'));
        setSupplierNameList(supplierData)
      }
    } else {
      setTitle("");
      setData([]);
    }
    if (count < 30) {
      count = 30;
    } else if (count > 90) {
      count = 90;
    }

    if (props.selectMenuType) {
      setMaxHeight(count + "%")
    }

  }, [props.selectMenuType]);

  // const getAppointmentTypeData = async () => {
  //   var appointmentType = await f(false);

  //   appointmentType = Enumerable.from(appointmentType)
  //     .where((it) => it.Number !== "ME-TH-IA")
  //     .toArray();

  //   setData(appointmentType);
  // }

  const clickSelectedOtherCondition = (option, type) => {
    if (props.selectMenuType === "filters") {
      if (type === "category") {
        if (selectedCategoryRef.current.indexOf(option) === -1) {
          setSelectedCategory([...selectedCategoryRef.current.concat(option)]);
        } else {
          var allData = selectedCategoryRef.current;
          const newData = allData.filter(function (value) {
            return value !== option;
          });

          if (newData.length > 0) {
            setSelectedCategory([...newData]);
          } else {
            setSelectedCategory([]);
          }
        }
      } else if (type === "dose_format") {
        if (selectedDoseFormatRef.current.indexOf(option) === -1) {
          setSelectedDoseFormat([...selectedDoseFormatRef.current.concat(option)]);
        } else {
          var allData = selectedDoseFormatRef.current;
          const newData = allData.filter(function (value) {
            return value !== option;
          });

          if (newData.length > 0) {
            setSelectedDoseFormat([...newData]);
          } else {
            setSelectedDoseFormat([]);
          }
        }
      } else if (type === "supplier_name") {
        if (selectedSupplierNameRef.current.indexOf(option) === -1) {
          setSelectedSupplierName([...selectedSupplierNameRef.current.concat(option)]);
        } else {
          var allData = selectedSupplierNameRef.current;
          const newData = allData.filter(function (value) {
            return value !== option;
          });

          if (newData.length > 0) {
            setSelectedSupplierName([...newData]);
          } else {
            setSelectedSupplierName([]);
          }
        }
      }
      EventEmitter.emit("save-selected_menu", { value: option, select_menu: props.selectMenuType, type: type });
    } else {
      if (selectedMenuRef.current.indexOf(option) === -1) {
        setSelectedMenu([...selectedMenuRef.current.concat(option)]);
      } else {
        var allData = selectedMenuRef.current;
        const newData = allData.filter(function (value) {
          return value !== option;
        });

        if (newData.length > 0) {
          setSelectedMenu([...newData]);
        } else {
          setSelectedMenu([]);
        }
      }
    }
  }

  const formatNumber = (num) => {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
  }

  const getRadioButtonView = () => {
    const list = [];

    dataRef.current.map((value, index) => {
      list.push(<div key={index} className={`radio-menu-list ${index === 0 ? "first" : ""} ${selectedMenuRef.current === index ? "selected" : ""}`} onClick={() => setSelectedMenu(index)}>
        <div className="text">
          <div className="name">{props.selectMenuType === "appointment_type" ? value.name : value}</div>
          <div className="price">${isNaN(value.price) ? "$0.00" : formatNumber(value.price.toFixed(2))}</div>
        </div>
        <div className="check">
          {selectedMenuRef.current === index ?
            <RadioButtonCheckedRoundedIcon style={{ color: "#50A453", fontSize: "20px", height: "20px" }} /> :
            <RadioButtonUncheckedRoundedIcon style={{ color: "#979797", fontSize: "20px", height: "20px" }} />
          }
        </div>
      </div>)
    })
    return <>{list}</>
  }

  const getSingleSelectView = () => {
    const list = [];

    dataRef.current.map((value, index) => {
      list.push(<div key={index} className={`select-menu-list ${selectedMenuRef.current === index + 1 ? "selected" : ""}`} onClick={() => setSelectedMenu(index + 1)}>
        <div>{props.selectMenuType === "region" || props.selectMenuType === "delivery_state" ? value.name : value}</div>
        <div className="check">
          {selectedMenuRef.current === index + 1 ? <CheckRoundedIcon style={{ color: "#50A453", fontSize: "17px", height: "17px" }} /> : ''}
        </div>
      </div>)
      if (index != dataRef.current.length - 1) {
        list.push(<div key={`border-${index}`} className="select-menu-border"></div>)
      }
    })
    return <>{list}</>
  }

  const getMultiSelectView = () => {
    const list = [];

    if (props.selectMenuType === "filters") {
      const category_list = [];
      const dose_format_list = [];
      const supplier_name_list = [];

      categoryList.map((value, index) => {
        category_list.push(<div key={index} className={`select-menu-list ${selectedCategoryRef.current.length > 0 && selectedCategoryRef.current !== 0 ? selectedCategoryRef.current.indexOf(value.Id) !== -1 ? "selected" : "" : ""}`} onClick={() => clickSelectedOtherCondition(value.Id, "category")}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ marginRight: " 16px" }}>
              <Checkbox
                style={{ padding: "0", width: "16px", height: "16px" }}
                checked={selectedCategoryRef.current.length > 0 && selectedCategoryRef.current !== 0 ? selectedCategoryRef.current.indexOf(value.Id) !== -1 ? true : false : false}
                icon={<CheckBoxOutlineBlankRoundedIcon style={{ color: "#DEE5EF" }} />}
                checkedIcon={<CheckBoxRoundedIcon style={{ color: "#50A453" }} />}
              />
            </div>
            <div style={{ paddingTop: "2px" }}>{value.Name}</div>
          </div>
          <div className="check"></div>
        </div>)
        if (index != dataRef.current.length - 1) {
          category_list.push(<div key={`border-${index}`} className="select-menu-border"></div>)
        }
      })

      doseFormatListRef.current.map((value, index) => {
        dose_format_list.push(<div key={index} className={`select-menu-list ${selectedDoseFormatRef.current.length > 0 && selectedDoseFormatRef.current !== 0 ? selectedDoseFormatRef.current.indexOf(value.Id) !== -1 ? "selected" : "" : ""}`} onClick={() => clickSelectedOtherCondition(value.Id, "dose_format")}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ marginRight: " 16px" }}>
              <Checkbox
                style={{ padding: "0", width: "16px", height: "16px" }}
                checked={selectedDoseFormatRef.current.length > 0 && selectedDoseFormatRef.current !== 0 ? selectedDoseFormatRef.current.indexOf(value.Id) !== -1 ? true : false : false}
                icon={<CheckBoxOutlineBlankRoundedIcon style={{ color: "#DEE5EF" }} />}
                checkedIcon={<CheckBoxRoundedIcon style={{ color: "#50A453" }} />}
              />
            </div>
            <div style={{ paddingTop: "2px" }}>{value.Name}</div>
          </div>
          <div className="check"></div>
        </div>)
        if (index != dataRef.current.length - 1) {
          dose_format_list.push(<div key={`border-${index}`} className="select-menu-border"></div>)
        }
      })

      supplierNameListRef.current.map((value, index) => {
        supplier_name_list.push(<div key={index} className={`select-menu-list ${selectedSupplierNameRef.current.length > 0 && selectedSupplierNameRef.current !== 0 ? selectedSupplierNameRef.current.indexOf(value.Id) !== -1 ? "selected" : "" : ""}`} onClick={() => clickSelectedOtherCondition(value.Id, "supplier_name")}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ marginRight: " 16px" }}>
              <Checkbox
                style={{ padding: "0", width: "16px", height: "16px" }}
                checked={selectedSupplierNameRef.current.length > 0 && selectedSupplierNameRef.current !== 0 ? selectedSupplierNameRef.current.indexOf(value.Id) !== -1 ? true : false : false}
                icon={<CheckBoxOutlineBlankRoundedIcon style={{ color: "#DEE5EF" }} />}
                checkedIcon={<CheckBoxRoundedIcon style={{ color: "#50A453" }} />}
              />
            </div>
            <div style={{ paddingTop: "2px" }}>{value.Name}</div>
          </div>
          <div className="check"></div>
        </div>)
        if (index != dataRef.current.length - 1) {
          supplier_name_list.push(<div key={`border-${index}`} className="select-menu-border"></div>)
        }
      })

      return <>
        <div className="select-menu-title">Category</div>
        <div>{category_list}</div>
        <div className="select-menu-title" style={{ marginTop: "20px" }}>Dose Format</div>
        <div>{dose_format_list}</div>
        <div className="select-menu-title" style={{ marginTop: "20px" }}>Supplier</div>
        <div>{supplier_name_list}</div>
      </>
    } else {
      dataRef.current.map((value, index) => {
        list.push(<div key={index} className={`select-menu-list ${selectedMenuRef.current.length > 0 && selectedMenuRef.current !== 0 ? selectedMenuRef.current.indexOf(value) !== -1 ? "selected" : "" : ""}`} onClick={() => clickSelectedOtherCondition(value)}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ marginRight: " 16px" }}>
              <Checkbox
                style={{ padding: "0", width: "16px", height: "16px" }}
                checked={selectedMenuRef.current.length > 0 && selectedMenuRef.current !== 0 ? selectedMenuRef.current.indexOf(value) !== -1 ? true : false : false}
                icon={<CheckBoxOutlineBlankRoundedIcon style={{ color: "#DEE5EF" }} />}
                checkedIcon={<CheckBoxRoundedIcon style={{ color: "#50A453" }} />}
              />
            </div>
            <div style={{ paddingTop: "2px" }}>{props.selectMenuType === "region" ? value.name : value}</div>
          </div>
          <div className="check"></div>
        </div>)
        if (index != dataRef.current.length - 1) {
          list.push(<div key={`border-${index}`} className="select-menu-border"></div>)
        }
      })

      return <>{list}</>
    }
  }

  const saveSelectedMenu = () => {
    if (props.selectMenuType === "filters") {
      EventEmitter.emit("show_select_menu", { value: false });
    } else {
      EventEmitter.emit("save-selected_menu", { value: selectedMenuRef.current, type: props.selectMenuType });
      EventEmitter.emit("show_select_menu", { value: false });
    }
  }

  const closeSelectedMenu = () => {
    setSelectedMenu(0);
    EventEmitter.emit("show_select_menu", { value: false });
  }

  const titleView = () => {
    return (
      <div className="select-menu-wrapper-top">
        <div className={`select-menu-title ${props.selectMenuType === "appointment_type" ? "custom" : ""}`}>
          {props.selectMenuType === "appointment_type" ? <div className="side">  <CloseRoundedIcon style={{ fontSize: "20px", cursor: "pointer", paddingTop: "3px" }} onClick={() => { closeSelectedMenu(); }} /></div> : ""}
          <div className="title" style={props.selectMenuType === "filters" ? { textAlign: "center" } : {}}>{titleRef.current}</div>
          {props.selectMenuType === "appointment_type" ? <div className="side"></div> : ""}
        </div>
        <div className="select-menu-content">
          {props.selectMenuType === "filters" ? getMultiSelectView()
            : props.selectMenuType === "appointment_type" ? getRadioButtonView()
              : getSingleSelectView()}
        </div>
      </div >
    )
  }

  const confirmButton = () => {
    if (props.selectMenuType) {
      return (
        <div className={`select-menu-confirm-button ${selectedMenuRef.current === 0 ? "disabled" : ""}`}>
          <button onClick={() => saveSelectedMenu()}>Done</button>
        </div>
      )
    }
  }

  return (
    <div className="select-menu-container-main">
      <div className="select-menu-container">
        <OutsideClickHandler onOutsideClick={() => { closeSelectedMenu(); }}>
          <div className="select-menu-wrapper" style={{ "--height": maxHeightRef.current }}>
            <div className={`select-menu-wrapper-container ${props.selectMenuType === "appointment_type" ? "custom" : ""}`}>
              {titleView()}
              {confirmButton()}
            </div>
          </div>
        </OutsideClickHandler>
      </div>
    </div>
  )
}


export default SelectMenuPage;